import {connect} from 'react-redux'
import Controls from '../components/Controls.jsx'
import {
  playPause,
  playNext,
  playNextPlaylist,
  updateCurrentTime,
  updateProgress,
  scrubbingOn,
  scrubbingOff,
  mute
} from '../../../actions/Actions.js'

// Map Redux state to component props
function mapStateToProps (state) {
  return {
    playback: state.radio.playback,
    track: state.radio.track,
    tracks: state.radio.tracks,
    total: state.radio.total,
    mute: state.radio.mute,
    playlist: state.radio.playlist,
    playlists: state.radio.playlists,
    progress: state.radio.progress,
    currentTime: state.radio.currentTime,
    duration: state.radio.duration,
    scrubbing: state.radio.scrubbing
  }
}

// Map Redux actions to component props
function mapDispatchToProps (dispatch) {
  return {
    onPlayPause: () => dispatch(playPause()),
    onPlayNext: () => dispatch(playNext()),
    onPlayNextPlaylist: (playlist) => dispatch(playNextPlaylist(playlist)),
    onMute: () => dispatch(mute()),
    onSetCurrentTime: (time) => dispatch(updateCurrentTime(time)),
    onSetProgress: (n) => dispatch(updateProgress(n)),
    scrubbingOn: () => dispatch(scrubbingOn()),
    scrubbingOff: () => dispatch(scrubbingOff())
  }
}

// Connected Component
const ControlsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Controls)

export default ControlsContainer
